// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/lib/font-awesome/css/font-awesome.min.css
// module id = 21
// module chunks = 0